module.exports = __webpack_public_path__ + "img/1.59ed9977.jpg";